/**
 * Get the data for a previous quiz
 * @param {object} data
 */
const getQuizData = async (hash) => {

    const params = new URLSearchParams({
      hash: hash
    });
    
    try {
      const response = await fetch(`/wp-json/quiz/get?${params}`, {
        method: 'GET',
      });
  
      const json = await response.json();
      const { success, data = {} } = json;
  
      if (success) {
        return data;
      }
  
      console.warn(data);
      return false;
      
    } catch (error) {
      console.error(error);
    }
};

export default getQuizData;